import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dp__marker_dot"
}

interface Props {
  monthText: string,
  selectedYear: number,
  monthValue: number,
  isActiveMonth: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CxMonthCell',
  props: {
    monthText: {},
    selectedYear: {},
    monthValue: {},
    isActiveMonth: { type: Boolean }
  },
  setup(__props: any) {


const props = __props;

const isCurrentMonth = () => {
  const today = new Date();
  return (today.getFullYear() === props.selectedYear) && (today.getMonth() === props.monthValue);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["cx-month-cell", { 'cx-month-cell--current': isCurrentMonth() }])
  }, [
    _createTextVNode(_toDisplayString(_ctx.monthText) + " ", 1),
    (_ctx.isActiveMonth)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})